

























































import { Mixins, Component } from "vue-property-decorator";
import ClientsMixin from "@/mixins/http/ClientsMixin";
import Page from "@/views/Page.vue";
import { Company, Client } from "@/models";
import { currentUserStore } from "@/store/typed";
import ClientsShowTabs from "./Tabs.vue";
import { RegisterHttp } from "../../utils/Decorators";
import RequestData from "@/store/types/RequestData";
import VContentLoading from "@/components/VContentLoading.vue";

const GET_CLIENT_TAG = "get_client";

@Component({ components: { Page, ClientsShowTabs, VContentLoading } })
export default class ClientShow extends Mixins(ClientsMixin) {
  company: Company = null;
  client: Client = null;
  taxData: { label: string; value: string }[] = [];

  @RegisterHttp(GET_CLIENT_TAG) readonly clientRequest!: RequestData;

  get loading() {
    return this.clientRequest?.loading;
  }

  async mounted() {
    this.company = currentUserStore.company;
    await this.loadClient();
  }

  async loadClient() {
    this.client = await this.getClient(
      this.$route.params.id,
      this.company.id,
      GET_CLIENT_TAG
    );
    this.taxData.push({ label: "Name", value: this.client.name });
    this.taxData.push({
      label: "Business name",
      value: this.client?.businessName,
    });
    this.taxData.push({ label: "Email", value: this.client.email });
    this.taxData.push({ label: "Phone", value: this.client.phone });
  }
}
